<template>
  <div>
    <vs-popup
      :title="$t('AgentProductsSegment') + ':  ' + agentName"
      :active.sync="showModal"
    >
      <data-grid
        ref="grid"
        stripe
        :data-source="gridDataSource"
        :search-data="gridSearchData"
        :columns="[{ title: $t('ProductSegment') }]"
      >
        <template slot-scope="{ row }">
          <td style="width: 96%">
            {{ row.name }}
          </td>
        </template>
      </data-grid>
    </vs-popup>
  </div>
</template>
<script>
import DataGrid from "@/components/datagrid/DataGrid";
export default {
  name:"saleManagement_BasicDefinitions_productSegment_DashboardAgentSegmentPopup",
  props: {
    show: { default: false },
    agentSegmentInfoApi: {
      default: {},
    },
    agentName: {
      default: {},
    },
    keywords: {},
  },
  data() {
    return {
      gridDataSource: { data: [] },
      gridSearchData: {},
      agentSegmentInfo: {},
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("finish");
      },
    },
  },
  watch: {
    show() {
      if (this.show == true) {
        this.gridDataSource = {
          type: "app",
          service: this.agentSegmentInfoApi,
        };
        setTimeout(() => {
          this.$refs.grid.renderGrid();
        }, 0);
      }
    },
  },
  components: { DataGrid },
};
</script>





